export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  bot: {
    count: 'botCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  pending: {
    count: 'pendingCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  open: {
    count: 'openCount', 
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  resolved: {
    count: 'resolvedCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
};
